export const linksInfo = [
  {
    title: 'Контакты можно найти на странице резюме hh.ru:',
    labelDesktop: 'Ссылка на резюме (hh.ru)',
    labelMobile: 'Ссылка на резюме (hh.ru)',
    href: 'https://hh.ru/applicant/resumes/view?resume=fff97ac1ff0d88607e0039ed1f4a39617a3041',
  },
  {
    title: 'Исходный код:',
    labelDesktop: 'https://github.com/vkoshcheev/resume',
    labelMobile: 'Ссылка на исходный код страницы',
    href: 'https://github.com/vkoshcheev/resume',
  },
  {
    title: 'Ссылка на github:',
    labelDesktop: 'https://github.com/vkoshcheev',
    labelMobile: 'Ссылка на github',
    href: 'https://github.com/vkoshcheev',
  },
  {
    title: 'Пет-проект - курсы валют стран СНГ:',
    labelDesktop: 'https://vkoshcheev.github.io/exchange-rates/',
    labelMobile: 'Пет-проект - курсы валют стран СНГ',
    href: 'https://vkoshcheev.github.io/exchange-rates/',
  },
  {
    title: 'Пет-проект - фича FFmpeg WebAssembly (Vercel):',
    labelDesktop: 'https://remove-duplicate-frames.vercel.app/',
    labelMobile: 'Пет-проект - фича FFmpeg WebAssembly',
    href: 'https://remove-duplicate-frames.vercel.app/',
  },
];